export default __webpack_public_path__ + "static/media/p17.38db6a49.jpg";